import React from 'react';
import { Check, Zap, Gift, Clock, ShieldCheck, Download } from 'lucide-react';
import { PremiumCTAButton } from './ui/PremiumCTAButton';
import { motion } from 'framer-motion';
export function BundleOfferSection() {
  const bonusBooks = ['Enfoque sin Estrés', 'Protege tu Enfoque', 'Plan de Arranque: Empieza Ya', 'Enfoque sin Distracción', 'Reuniones Efectivas sin Caos', 'Sistema Anticaos de Mensajes'];
  return <section className="py-20 md:py-32 bg-gradient-to-br from-dark-900 via-black to-dark-900 relative overflow-hidden" data-id="element-1">
      {/* Animated background elements */}
      <div className="absolute inset-0" data-id="element-2">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-3"></div>
        <motion.div className="absolute top-1/4 right-0 w-96 h-96 bg-gold-500/10 rounded-full blur-[120px]" animate={{
        scale: [1, 1.2, 1],
        opacity: [0.1, 0.15, 0.1]
      }} transition={{
        duration: 4,
        repeat: Infinity
      }} data-id="element-4" />
        <motion.div className="absolute bottom-1/4 left-0 w-96 h-96 bg-cyan-500/10 rounded-full blur-[120px]" animate={{
        scale: [1, 1.3, 1],
        opacity: [0.1, 0.15, 0.1]
      }} transition={{
        duration: 5,
        repeat: Infinity,
        delay: 1
      }} data-id="element-5" />
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-6">
        {/* Launch Badge */}
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-7">
          <div className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-gradient-to-r from-red-500/20 via-orange-500/20 to-yellow-500/20 border-2 border-orange-500/50 backdrop-blur-sm mb-6" data-id="element-8">
            <Zap className="w-6 h-6 text-orange-500 animate-pulse" data-id="element-9" />
            <span className="text-orange-500 font-bold uppercase tracking-wider text-lg" data-id="element-10">
              🚀 OFERTA DE LANZAMIENTO
            </span>
            <Zap className="w-6 h-6 text-orange-500 animate-pulse" data-id="element-11" />
          </div>
        </motion.div>

        {/* Main Headline */}
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-12">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold mb-4 leading-tight" data-id="element-13">
            <span className="text-white" data-id="element-14">SOLO </span>
            <span className="text-gradient-gold text-5xl md:text-7xl" data-id="element-15">
              $9.95
            </span>
          </h2>
          <h3 className="text-2xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-16">
            ADIÓS AL CAOS POR EL ESTRÉS LABORAL
          </h3>
          <p className="text-xl md:text-2xl text-gray-300 font-light max-w-3xl mx-auto" data-id="element-17">
            El Método CIERRE 90' para recuperar control, enfoque y calma mental
          </p>
        </motion.div>

        {/* Problem Statement */}
        <motion.div className="max-w-3xl mx-auto text-center mb-12" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} data-id="element-18">
          <p className="text-lg md:text-xl text-gray-300 leading-relaxed mb-4" data-id="element-19">
            Trabajas todo el día, pero terminas sin haber cerrado nada.
            <span className="text-white font-semibold" data-id="element-20">
              {' '}
              No es cansancio. Es ruido mental.
            </span>
          </p>
          <p className="text-lg md:text-xl text-gray-400" data-id="element-21">
            Este pack no es motivación. Es un sistema simple para cerrar
            pendientes en medio del caos laboral.
          </p>
        </motion.div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 mb-16 max-w-6xl mx-auto" data-id="element-22">
          {/* Left: Book Image */}
          <motion.div className="relative" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-23">
            <div className="relative bg-gradient-to-br from-gold-500/10 to-yellow-500/5 border-2 border-gold-500/30 rounded-3xl p-8 md:p-12" data-id="element-24">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gold-500/20 blur-[80px] rounded-full" data-id="element-25"></div>

              <img src="https://cdn.magicpatterns.com/uploads/nVi5D7PkQzVXACwNVXfAGp/EBOOK_PRINCIPAL.png" alt="Adiós al Caos - Libro Principal" className="relative w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-26" />

              {/* Badge */}
              <div className="absolute -top-4 -right-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white px-6 py-3 rounded-full text-sm font-bold uppercase shadow-xl transform rotate-6" data-id="element-27">
                + 6 BONOS GRATIS
              </div>
            </div>
          </motion.div>

          {/* Right: What You Get */}
          <motion.div className="flex flex-col justify-center" initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} data-id="element-28">
            <div className="bg-dark-800/50 border border-gold-500/20 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-29">
              <div className="flex items-center gap-3 mb-6" data-id="element-30">
                <Gift className="w-8 h-8 text-gold-500" data-id="element-31" />
                <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-32">
                  📦 QUÉ RECIBES HOY
                </h3>
              </div>

              {/* Main Book */}
              <div className="mb-6 pb-6 border-b border-white/10" data-id="element-33">
                <div className="flex items-start gap-3 mb-2" data-id="element-34">
                  <Check className="w-6 h-6 text-gold-500 flex-shrink-0 mt-1" data-id="element-35" />
                  <div data-id="element-36">
                    <p className="text-white font-bold text-lg mb-1" data-id="element-37">
                      Ebook principal: Adiós al Caos por el Estrés Laboral
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-38">
                      Sistema visual de productividad de alto nivel.
                    </p>
                  </div>
                </div>
              </div>

              {/* Bonus Books */}
              <div className="mb-6" data-id="element-39">
                <p className="text-white font-bold mb-4 flex items-center gap-2" data-id="element-40">
                  <Check className="w-5 h-5 text-green-500" data-id="element-41" />6 ebooks de bono
                  GRATIS, incluyendo:
                </p>
                <div className="grid grid-cols-1 gap-2 ml-8" data-id="element-42">
                  {bonusBooks.map((bonus, index) => <div key={index} className="flex items-center gap-2 text-gray-300 text-sm" data-id="element-43">
                      <div className="w-1.5 h-1.5 bg-gold-500 rounded-full" data-id="element-44"></div>
                      <span data-id="element-45">{bonus}</span>
                    </div>)}
                </div>
              </div>

              {/* Method Highlight */}
              <div className="bg-gradient-to-r from-gold-500/10 to-yellow-500/10 border border-gold-500/30 rounded-xl p-4 mt-6" data-id="element-46">
                <div className="flex items-center gap-2 mb-2" data-id="element-47">
                  <Clock className="w-5 h-5 text-gold-500" data-id="element-48" />
                  <p className="text-gold-500 font-bold" data-id="element-49">
                    ⏱️ EL MÉTODO CIERRE 90'
                  </p>
                </div>
                <p className="text-white text-sm mb-2" data-id="element-50">
                  Un bloque. Una tarea clave. Un timer. Cierre real.
                </p>
                <p className="text-gray-400 text-xs italic" data-id="element-51">
                  Menos estrés no por descansar más, sino por cerrar lo que
                  importa.
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* URGENCY BANNER - NEW */}
        <motion.div className="max-w-4xl mx-auto mb-6" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.55
      }} data-id="element-52">
          <motion.div className="bg-gradient-to-r from-red-600 via-orange-600 to-red-600 text-white rounded-xl p-3 md:p-4 text-center border-2 border-red-400/50 shadow-2xl" animate={{
          boxShadow: ['0 0 15px rgba(220, 38, 38, 0.5)', '0 0 30px rgba(220, 38, 38, 0.8)', '0 0 15px rgba(220, 38, 38, 0.5)']
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-53">
            <div className="flex items-center justify-center gap-2 mb-1.5" data-id="element-54">
              <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-55" />
              <h3 className="text-base md:text-lg lg:text-xl font-black uppercase tracking-wider" data-id="element-56">
                ⏰ OFERTA POR TIEMPO LIMITADO
              </h3>
              <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-57" />
            </div>
            <p className="text-xs md:text-sm font-semibold text-white/90" data-id="element-58">
              Este precio especial puede terminar en cualquier momento
            </p>
          </motion.div>
        </motion.div>

        {/* Pricing Section - REDESIGNED */}
        <motion.div className="max-w-4xl mx-auto mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} data-id="element-59">
          {/* 3D Premium Pricing Card */}
          <div className="relative perspective-1000" data-id="element-60">
            {/* Outer glow rings */}
            <div className="absolute inset-0 bg-gradient-to-r from-gold-500/20 via-yellow-500/30 to-gold-500/20 blur-3xl animate-pulse" data-id="element-61"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 to-red-500/10 blur-2xl" data-id="element-62"></div>

            {/* Main 3D Card Container */}
            <motion.div className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 rounded-3xl overflow-hidden" style={{
            transformStyle: 'preserve-3d',
            transform: 'rotateX(2deg)'
          }} whileHover={{
            transform: 'rotateX(0deg) scale(1.02)'
          }} transition={{
            duration: 0.3
          }} data-id="element-63">
              {/* Premium metallic border frame */}
              <div className="absolute inset-0 rounded-3xl p-[3px] bg-gradient-to-br from-gold-500 via-yellow-400 to-gold-600" data-id="element-64">
                <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-gray-900 via-black to-gray-900" data-id="element-65"></div>
              </div>

              {/* Inner metallic frame */}
              <div className="absolute inset-[3px] rounded-3xl border-2 border-gold-500/30 shadow-[inset_0_2px_20px_rgba(212,175,55,0.1)]" data-id="element-66"></div>

              {/* Animated shine sweep */}
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent" animate={{
              x: ['-200%', '200%']
            }} transition={{
              duration: 3,
              repeat: Infinity,
              repeatDelay: 2,
              ease: 'easeInOut'
            }} data-id="element-67" />

              {/* Decorative corner accents */}
              <div className="absolute top-0 left-0 w-20 h-20 border-t-4 border-l-4 border-gold-500 rounded-tl-3xl" data-id="element-68"></div>
              <div className="absolute top-0 right-0 w-20 h-20 border-t-4 border-r-4 border-gold-500 rounded-tr-3xl" data-id="element-69"></div>
              <div className="absolute bottom-0 left-0 w-20 h-20 border-b-4 border-l-4 border-gold-500 rounded-bl-3xl" data-id="element-70"></div>
              <div className="absolute bottom-0 right-0 w-20 h-20 border-b-4 border-r-4 border-gold-500 rounded-br-3xl" data-id="element-71"></div>

              {/* Content */}
              <div className="relative z-10 p-6 sm:p-8 md:p-12" data-id="element-72">
                {/* PRECIO ESPECIAL badge - NOW INSIDE at top */}
                <div className="text-center mb-6" data-id="element-73">
                  <div className="relative inline-block" data-id="element-74">
                    <div className="absolute inset-0 bg-gradient-to-r from-orange-500 to-red-500 blur-xl opacity-75" data-id="element-75"></div>
                    <div className="relative bg-gradient-to-r from-orange-500 via-red-500 to-orange-600 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-full text-sm sm:text-base md:text-lg font-black uppercase tracking-wider shadow-2xl border-2 border-white/20" data-id="element-76">
                      <span className="flex items-center gap-2" data-id="element-77">
                        <Zap className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" data-id="element-78" />
                        💰 PRECIO ESPECIAL
                        <Zap className="w-5 h-5 sm:w-6 sm:h-6 animate-pulse" data-id="element-79" />
                      </span>
                    </div>
                  </div>
                </div>

                {/* Price comparison */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-5 sm:gap-8 mb-8" data-id="element-80">
                  {/* Old price */}
                  <div className="text-center sm:text-left" data-id="element-81">
                    <p className="text-gray-400 text-sm sm:text-base mb-2 font-medium" data-id="element-82">
                      Valor real del pack:
                    </p>
                    <div className="relative inline-block" data-id="element-83">
                      <p className="text-4xl sm:text-5xl text-gray-500 line-through font-bold" data-id="element-84">
                        $250.00
                      </p>
                      <div className="absolute inset-0 bg-red-500/20 blur-xl" data-id="element-85"></div>
                    </div>
                  </div>

                  {/* Arrow */}
                  <motion.div animate={{
                  x: [0, 10, 0]
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-86">
                    <div className="text-5xl sm:text-6xl md:text-7xl font-bold bg-gradient-to-r from-gold-400 via-yellow-300 to-gold-500 bg-clip-text text-transparent drop-shadow-[0_0_30px_rgba(212,175,55,0.5)]" data-id="element-87">
                      →
                    </div>
                  </motion.div>

                  {/* New price */}
                  <div className="text-center sm:text-left" data-id="element-88">
                    <motion.div animate={{
                    scale: [1, 1.05, 1]
                  }} transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: 'easeInOut'
                  }} data-id="element-89">
                      <div className="flex items-center gap-2 mb-2 justify-center sm:justify-start" data-id="element-90">
                        <span className="text-2xl animate-pulse" data-id="element-91">🔥</span>
                        <p className="text-orange-500 font-black text-base sm:text-lg md:text-xl uppercase tracking-wider" data-id="element-92">
                          HOY:
                        </p>
                      </div>
                      <div className="relative inline-block" data-id="element-93">
                        {/* Glow effect */}
                        <div className="absolute inset-0 bg-gradient-to-r from-gold-500 via-yellow-400 to-gold-500 blur-2xl opacity-50 animate-pulse" data-id="element-94"></div>

                        {/* Price */}
                        <p className="relative text-6xl sm:text-7xl md:text-8xl font-black bg-gradient-to-br from-gold-300 via-yellow-400 to-gold-500 bg-clip-text text-transparent drop-shadow-2xl" style={{
                        textShadow: '0 0 40px rgba(212,175,55,0.8), 0 0 80px rgba(212,175,55,0.4)'
                      }} data-id="element-95">
                          $9.95
                        </p>
                      </div>
                      <p className="text-gray-400 text-sm sm:text-base mt-2 font-medium" data-id="element-96">
                        USD
                      </p>
                    </motion.div>
                  </div>
                </div>

                {/* Savings badge */}
                <motion.div className="inline-block mb-6" animate={{
                scale: [1, 1.08, 1]
              }} transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: 'easeInOut'
              }} data-id="element-97">
                  <div className="relative" data-id="element-98">
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-emerald-500 blur-xl opacity-75" data-id="element-99"></div>
                    <div className="relative bg-gradient-to-r from-green-500 via-emerald-500 to-green-600 border-2 border-green-300/50 rounded-full px-6 sm:px-8 py-2.5 sm:py-3 shadow-2xl" data-id="element-100">
                      <p className="text-white font-black text-base sm:text-lg flex items-center gap-2" data-id="element-101">
                        <span className="text-xl sm:text-2xl" data-id="element-102">💎</span>
                        Ahorras $240.05 (96% OFF)
                      </p>
                    </div>
                  </div>
                </motion.div>

                {/* Bottom text */}
                <div className="space-y-2" data-id="element-103">
                  <p className="text-white text-lg sm:text-xl font-bold" data-id="element-104">
                    Un solo pago. Acceso inmediato.
                  </p>
                  <p className="text-gray-400 text-sm sm:text-base" data-id="element-105">
                    🎁 Incluye 6 ebooks de bono GRATIS
                  </p>
                </div>
              </div>

              {/* Bottom decorative line */}
              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-106"></div>
            </motion.div>
          </div>
        </motion.div>

        {/* Ideal Para Section */}
        <motion.div className="max-w-4xl mx-auto mb-8" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.65
      }} data-id="element-107">
          <div className="bg-gradient-to-br from-dark-800/80 to-dark-900/80 border border-gold-500/20 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-108">
            <div className="flex items-center gap-3 mb-4" data-id="element-109">
              <span className="text-3xl" data-id="element-110">💼</span>
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-111">
                Ideal para:
              </h3>
            </div>
            <p className="text-gray-300 text-base md:text-lg leading-relaxed" data-id="element-112">
              Profesionales, freelancers, emprendedores y cualquier persona que
              trabaja desde casa, estudiantes o en oficina digital y busca{' '}
              <span className="text-gold-500 font-bold text-lg md:text-xl bg-gold-500/10 px-2 py-1 rounded" data-id="element-113">
                productividad real sin burnout
              </span>
              .
            </p>
          </div>
        </motion.div>

        {/* Entrega Instantanea */}
        <motion.div className="max-w-4xl mx-auto mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.68
      }} data-id="element-114">
          <div className="bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-2xl p-6 md:p-8 text-center" data-id="element-115">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-116">
              <Download className="w-6 h-6 text-green-500" data-id="element-117" />
              <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-118">
                📥 Entrega instantánea
              </h3>
            </div>
            <p className="text-gray-300 text-base md:text-lg" data-id="element-119">
              Descarga inmediata después de tu compra. Formato digital
              compatible con todos tus dispositivos.
            </p>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.7
      }} data-id="element-120">
          <PremiumCTAButton size="xl" data-id="element-121" />

          <p className="text-gray-300 mt-6 text-lg font-medium" data-id="element-122">
            👉 Descárgalo ahora y recupera el control hoy.
          </p>
        </motion.div>

        {/* Trust Badges */}
        <motion.div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} data-id="element-123">
          <div className="flex items-center gap-2" data-id="element-124">
            <Download className="w-4 h-4 text-gold-500" data-id="element-125" />
            <span data-id="element-126">Acceso digital inmediato</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-127">
            <Gift className="w-4 h-4 text-gold-500" data-id="element-128" />
            <span data-id="element-129">Plantillas incluidas</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-130">
            <ShieldCheck className="w-4 h-4 text-gold-500" data-id="element-131" />
            <span data-id="element-132">Garantía de 30 días</span>
          </div>
        </motion.div>

        {/* Social Proof */}
        <motion.div className="mt-12 text-center" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.9
      }} data-id="element-133">
          <div className="inline-flex items-center gap-2 text-green-500 text-sm bg-green-500/10 border border-green-500/30 rounded-full px-6 py-3" data-id="element-134">
            <Check className="w-4 h-4" data-id="element-135" />
            <span className="font-medium" data-id="element-136">
              Más de 5,000 profesionales ya transformaron su productividad
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}